import React from 'react';
import { config } from '../../config';
import { useAppSettings } from '../../contexts/AppSettingsContext';

const Footer = ({ className = '' }) => {
    // Get copyright text from config
    const copyrightText = config.COPYRIGHT_TEXT;
    const poweredBy = config.POWERED_BY;
    
    // Get app settings
    const { getTermsUrl, getPrivacyUrl } = useAppSettings();

    return (
        <footer className={`bg-white border-t border-gray-200 py-4 px-6 ${className}`}>
            <div className="flex flex-col sm:flex-row justify-between items-center text-sm text-gray-600">
                <div className="mb-2 sm:mb-0">
                    <p>{copyrightText}</p>
                    {(getTermsUrl() || getPrivacyUrl()) && (
                        <div className="flex space-x-4 mt-1">
                            {getTermsUrl() && (
                                <a 
                                    href={getTermsUrl()} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="text-blue-600 hover:text-blue-800 text-xs"
                                >
                                    Terms of Service
                                </a>
                            )}
                            {getPrivacyUrl() && (
                                <a 
                                    href={getPrivacyUrl()} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="text-blue-600 hover:text-blue-800 text-xs"
                                >
                                    Privacy Policy
                                </a>
                            )}
                        </div>
                    )}
                </div>
                <div className="flex space-x-4">
                    <span className="text-xs">
                        {poweredBy}
                    </span>
                </div>
            </div>
        </footer>
    );
};

export default Footer;